// import React from 'react';
// import Navbar from '../components/App/Navbar';
// import Footer from '../components/App/Footer';
// import Layout from '../components/App/Layout';
// import Banner from '../components/Index/Banner';
// import OurSolutions from '../components/Index/OurSolutions';
// import OurServices from '../components/Index/OurServices';
// import OurFeatures from '../components/Index/OurFeatures';
// import TeamMember from '../components/Index/TeamMember';
// import RecentProjects from '../components/Index/RecentProjects';
// import Pricing from '../components/Index/Pricing';
// import Testimonials from '../components/Index/Testimonials';
// import Partner from '../components/Index/Partner';
// import ProjectStartArea from '../components/Index/ProjectStartArea';
// import OurBlog from '../components/Index/OurBlog';

// const Home = () => {
// 	return (
// 		<Layout>
// 			<Navbar />
// 			<Banner />
// 			<OurSolutions />
// 			<OurServices />
// 			<OurFeatures />
// 			<TeamMember />
// 			<RecentProjects />
// 			<Pricing />
// 			<Testimonials />
// 			<Partner />
// 			<OurBlog />
// 			<ProjectStartArea />
// 			<Footer />
// 		</Layout>
// 	);
// };

// export default Home;

import React from "react";
import Layout from "../components/App/Layout";
import NavbarTwo from "../RaymonComponents/Navbar";
// import Footer from "../RaymonComponents/Footer"
// import FeaturedServices from "../RaymonComponents/FeaturedServices"
// import Services from "../RaymonComponents/Services"
// import FunFacts from "../RaymonComponents/FunFacts"
// import Pricing from "../RaymonComponents/Pricing"
import MainBanner from "../RaymonComponents/MainBanner";
import { Helmet } from "react-helmet";
import Gallery from "../RaymonComponents/Gallery";
import NewNews from "../RaymonComponents/NewNews";
import NewsDetails from "../RaymonComponents/news/NewsDetails";
import NewsBolg from "../RaymonComponents/news/NewsBolg";
import BestStudents from "../RaymonComponents/BestStudents";
import Footer from "../RaymonComponents/Footer2";
import WordsEdlers from "../RaymonComponents/WordsEdlers";
import { Router } from "@reach/router";
import GuideModal from "../RaymonComponents/modal/GuideModal";
import Councils from "../RaymonComponents/Councils";
import { request, gql } from "graphql-request";
import { REQUEST_URL } from "../RaymonComponents/RequestUrl";
// import Footer from "../RaymonComponents/Footer";
// import WhyChooseUs from "../RaymonComponents/WhyChooseUs"
// import ExploreLearning from "../RaymonComponents/ExploreLearning"

const GET_LITTLE_BEVEFACTORS = gql`
  {
    getAllWebsiteKhayerinKochak {
      _id
      name
      surname
      pictureLink
      phoneNumber
    }
  }
`;

const ALL_STUDENTS_COUNCIL = gql`
  {
    getAllWebsiteCommunity {
      _id
      title
      sale_tahsili
      pictureLink
      name
      surname
      phoneNumber
      votes
    }
  }
`;

const GET_SCHOOLS_COUNCIL = gql`
  {
    getAllWebsiteAnjomanOlia {
      _id
      name
      surname
      pictureLink
      title
      phoneNumber
    }
  }
`;

const Home = () => {
  const [openGuideModal, setOpenGuideModal] = React.useState(false);
  const [littleBenefactorList, setLittleBenefactorList] = React.useState([]);
  const [schoolCouncil, setSchoolCouncil] = React.useState([]);
  const [studentsCouncil, setStudentsCouncil] = React.useState([]);

  // React.useEffect(() => {
  //   const myTimeout = setTimeout(() => {
  //     handleOpenGuideModal();
  //   }, 5000);

  //   return () => {
  //     clearTimeout(myTimeout);
  //   };
  // }, []);

  React.useEffect(() => {
    request(REQUEST_URL, GET_LITTLE_BEVEFACTORS).then((data) => {
      if (data.getAllWebsiteKhayerinKochak !== null) {
        console.log(
          "getAllWebsiteKhayerinKochak:",
          data.getAllWebsiteKhayerinKochak
        );
        setLittleBenefactorList(data.getAllWebsiteKhayerinKochak);
      }
    });
  }, []);

  React.useEffect(() => {
    request(REQUEST_URL, GET_SCHOOLS_COUNCIL).then((data) => {
      if (data.getAllWebsiteAnjomanOlia !== null) {
        console.log("getAllWebsiteAnjomanOlia:", data.getAllWebsiteAnjomanOlia);
        setSchoolCouncil(data.getAllWebsiteAnjomanOlia);
      }
    });
  }, []);
  React.useEffect(() => {
    request(REQUEST_URL, ALL_STUDENTS_COUNCIL).then((data) => {
      if (data.getAllWebsiteCommunity !== null) {
        console.log("getAllWebsiteCommunity:", data.getAllWebsiteCommunity);
        setStudentsCouncil(data.getAllWebsiteCommunity);
      }
    });
  }, []);

  const handleOpenGuideModal = () => {
    setOpenGuideModal(true);
  };
  const handleCloseGuideModal = () => {
    setOpenGuideModal(false);
  };
  return (
    <>
      <Helmet>
        {/* <link
          rel="stylesheet"
          href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
          integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p"
          crossorigin="anonymous"
        /> */}
        <link rel="stylesheet" href="../assets/fontawesome/css/all.css" />
      </Helmet>
      <Layout>
        <NavbarTwo />
        <MainBanner />
        <NewNews />
        <WordsEdlers />
        {littleBenefactorList.length > 0 ||
          schoolCouncil.length > 0 ||
          studentsCouncil.length > 0 ? (
          <Councils
            littleBenefactorList={littleBenefactorList}
            schoolCouncil={schoolCouncil}
            studentsCouncil={studentsCouncil}
          />
        ) : (
          ""
        )}

        <Gallery />
        <BestStudents />
        <Footer />
        {/* <FeaturedServices />
            <WhyChooseUs />
            <Services />
            <FunFacts />
            <ExploreLearning />
            <Pricing />
            <Footer /> */}
      </Layout>
      <GuideModal open={openGuideModal} onClose={handleCloseGuideModal} />
    </>
  );
};

export default Home;
